import LoginForm from '../components/LoginForm';
import './LoginPage.css';
import { useLanguage } from '../utils/LanguageContext';
import translations from './LoginPage.lang.json';
import { NavigateButton } from '../components/common/CommonComponents';

const LoginPage = () => {
  const { lang } = useLanguage(translations);

  return (
    <main>
      <h2>{lang('login')}</h2>
      <div className="form-card">
        <div>
          <LoginForm />
          <p className="p-tag">{lang(`noAccount`)}</p>
          <NavigateButton to="/signup">{lang('createAccount')}</NavigateButton>
        </div>
      </div>
    </main>
  );
};

export default LoginPage;
